import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import {
  FooterNavKey,
  FOOTER_LAYOUTS,
  getMobileFooterVars,
} from "../../../common/mobileFooter";
import DraggableGamesFab from "./DraggableGamesFab";
import { FOOTER_NAV_META, isFooterItemActive } from "./navMeta";
import { MobileFooterVariantProps } from "./types";

const cookies = new Cookies();

const FooterShell = ({
  onCasino,
  footerId,
  schema,
  activeColor,
  ready,
}: MobileFooterVariantProps) => {
  const location = useLocation();
  const navigate = useNavigate();
  const isAuthenticated = useSelector((e: any) => e.isAuthenticated);
  const isLoggedIn = !!(
    cookies.get("skyTokenFront") || isAuthenticated?.isLogin
  );
  const layout = FOOTER_LAYOUTS[footerId] || FOOTER_LAYOUTS["games-six"];
  const vars = getMobileFooterVars(schema, activeColor);
  // Raised Home: skip Home active color on first paint; enable after any tab click/leave.
  const isRaisedHome = footerId === "default";
  const [allowRaisedHomeActive, setAllowRaisedHomeActive] = useState(
    () => !isRaisedHome || !isFooterItemActive("home", location.pathname)
  );

  useEffect(() => {
    if (!isRaisedHome || allowRaisedHomeActive) return;
    if (!isFooterItemActive("home", location.pathname)) {
      setAllowRaisedHomeActive(true);
    }
  }, [isRaisedHome, allowRaisedHomeActive, location.pathname]);

  const enableRaisedHomeActive = () => {
    if (isRaisedHome) setAllowRaisedHomeActive(true);
  };

  const handleTabClick = (key: FooterNavKey) => {
    enableRaisedHomeActive();
    if (key !== "home") return;
    // Even if already on `/`, treat as an intentional Home tap.
    navigate("/");
    window.scrollTo(0, 0);
  };

  const itemPath = (key: FooterNavKey) => {
    const meta = FOOTER_NAV_META[key];
    if (key === "account") return isLoggedIn ? meta.path || "/myAccount" : "/login";
    return meta.path || "/";
  };

  return (
    <div
      className={`mobilemenu footer-dynamic footer-style-${footerId}${ready ? " is-ready" : ""
        }`}
      data-mobile-footer={footerId}
    >
      {layout.gamesFab && (
        <DraggableGamesFab
          visible={isFooterItemActive("home", location.pathname)}
          onCasino={() => {
            enableRaisedHomeActive();
            onCasino(true);
          }}
        />
      )}
      <nav
        key={`${footerId}-${schema}-${activeColor}`}
        style={vars as React.CSSProperties}
      >
        <ul>
          {layout.items.map((key) => {
            const meta = FOOTER_NAV_META[key];
            const active = isFooterItemActive(key, location.pathname);
            const showActive =
              active &&
              !(isRaisedHome && !allowRaisedHomeActive && key === "home");
            const classNames = [
              layout.raised === "home" && key === "home" ? "main-nav" : "",
              key === "games" ? "game-nav" : "",
              showActive ? "select" : "",
            ]
              .filter(Boolean)
              .join(" ");

            const inner = (
              <>
                <img
                  className={meta.iconClass}
                  src={meta.icon}
                  alt={meta.label}
                />
                {meta.casino ? null : meta.label}
              </>
            );

            if (meta.casino) {
              return (
                <li key={key} id="mini" className={classNames}>
                  <a
                    onClick={() => {
                      enableRaisedHomeActive();
                      onCasino(true);
                    }}
                    className="ui-link"
                    style={{ fontWeight: 600 }}
                  >
                    {inner}
                  </a>
                </li>
              );
            }

            return (
              <li key={key} className={classNames}>
                <Link
                  className={key === "multi" ? "multi_market" : ""}
                  to={itemPath(key)}
                  onClick={() => handleTabClick(key)}
                  style={{ fontWeight: 600 }}
                >
                  {inner}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default FooterShell;
